import React from 'react';

const MetricsSection = () => {
  const metrics = [
    { value: "670+", label: "Customers" },
    { value: "100+", label: "Years Experience" },
    { value: "500+", label: "Projects" }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex flex-wrap justify-center items-center gap-8">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-900 to-slate-900 rounded-2xl p-10 shadow-2xl transform hover:scale-105 transition-all duration-300 border-4 border-amber-400 min-w-[280px]"
            >
              <div className="text-center">
                <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600 mb-4">
                  {metric.value}
                </div>
                <div className="text-xl text-white font-semibold uppercase tracking-wider">
                  {metric.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
